import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const Wrapper = styled.div`
  position: relative;
  display: inline-block;

  .filter-dropdown-toggle {
    background-color: #70bbfd;
    height: initial;
    padding: 0.5rem 1rem;
    color: white;
    border: none;
    border-radius: 0.25rem;
    cursor: pointer;

    &:hover {
      color: #646777;
    }
  }
`

const DropdownMenu = styled.div`
  position: absolute;
  right: 0;
  top: calc(100% + 6px);
  z-index: 1000;
  min-width: 200px;
  background: #fff;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.12);
  overflow: hidden;
`;

const DropdownItem = styled.button`
  width: 100%;
  text-align: left;
  border: none;
  background: transparent;
  padding: 0.5rem 0.75rem;
  cursor: pointer;

  &:hover {
    background: #f1f5f9;
  }
`;

export const AVAILABLE_FILTER_TYPES_TENANT = {
  week: {
    id: 1,
    label: 'global.Week',
    logType: 'week'
  },
  month: {
    id: 2,
    label: 'global.Month',
    logType: 'month'
  },
  year: {
    id: 3,
    label: 'global.Year',
    logType: 'year'
  }
};

export const AVAILABLE_FILTER_TYPES = {
  week: {
    id: 1,
    label: 'global.Week',
    logType: 'week'
  },
  month: {
    id: 2,
    label: 'global.Month',
    logType: 'month'
  },
  year: {
    id: 3,
    label: 'global.Year',
    logType: 'year'
  },
  challenges: {
    id: 4,
    label: 'global.challenges',
    logType: 'challenges'
  }
};


export const DASHBOARD_AVAILABLE_FILTER_TYPES = {
  ...AVAILABLE_FILTER_TYPES,
  range: {
    id: 5,
    label: 'global.range',
    logType: 'range'
  },
};

export const AVAILABLE_FILTER_TYPES_PRODUCTS = {
  week: {
    id: 1,
    label: 'global.Week',
    logType: 'week'
  },
  month: {
    id: 2,
    label: 'global.Month',
    logType: 'month'
  },
  year: {
    id: 3,
    label: 'global.Year',
    logType: 'year'
  },
};

const FilterDatePicker = ({
  filterBy = AVAILABLE_FILTER_TYPES.week,
  setFilterBy = () => null,
  filterTypes = AVAILABLE_FILTER_TYPES,
}) => {
  const [opened, setOpened] = React.useState(false);
  const wrapperRef = React.useRef(null);
  const [t] = useTranslation('common');

  const toggleDropdown = () => {
    setOpened((previousState) => !previousState);
  };

  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (!wrapperRef.current || wrapperRef.current.contains(event.target)) return;
      setOpened(false);
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <Wrapper ref={wrapperRef}>
      <button
        type="button"
        className="filter-dropdown-toggle ml-2 mb-0"
        onClick={toggleDropdown}
        aria-haspopup="menu"
        aria-expanded={opened}
      >
        {t('global.filterBy')}: {t(filterBy?.label)}
      </button>
      {opened && (
        <DropdownMenu role="menu">
          {Object.entries(filterTypes).map(([key, value]) => (
            <DropdownItem
              key={key}
              type="button"
              role="menuitem"
              tabIndex={0}
              onClick={() => {
                setFilterBy(value);
                setOpened(false);
              }}
            >
              {t(value.label)}
            </DropdownItem>
          ))}
        </DropdownMenu>
      )}
    </Wrapper>
  );
}

FilterDatePicker.propTypes = {
  filterBy: PropTypes.shape({
    id: PropTypes.number,
    label: PropTypes.string,
  }),
  setFilterBy: PropTypes.func,
};

export default FilterDatePicker;
